// Executes a grounded navigation TARGET by driving the app's REAL navigation contract — the same path the
// side menu / top-bar buttons use — rather than clicking a DOM node. That keeps the unsaved-changes guard,
// the FCA notice, and breadcrumbs intact, and works for destinations whose button may be off-screen.
//
// The app singletons this needs (the redux store, the history object, navigateWithPrompts) are loaded
// LAZILY inside the function, not imported at module top. navigateWithPrompts/config pull in the whole
// redux store graph, so an eager import would drag that (and its untransformed ESM deps) into every unit
// test that merely renders the assistant. Requiring them only when a navigation actually fires keeps this
// module free of import-time side effects. require() resolves the same transpiled modules webpack bundles.

const readFormDirty = store => {
    try {
        const state = store && store.getState ? store.getState() : null;
        return !!(state && state.commonReducer && state.commonReducer.isFormDirty);
    } catch (e) {
        return false;
    }
};

// Navigate to `target` ({ url, state?, bc? }). Routes through navigateWithPrompts so a dirty form / FCA
// notice prompts first (deferring the push), exactly like a manual click. Best-effort: a bad target or a
// throwing push is swallowed (navigation must never crash the chat). Returns true if a push was dispatched.
export const executeNavigation = target => {
    if (!target || !target.url) return false;
    // eslint-disable-next-line global-require
    const history = require("../../../../config/history").default;
    // eslint-disable-next-line global-require
    const { bulkResetBreadCrumpData } = require("../../../../config/utils");
    // eslint-disable-next-line global-require
    const { navigateWithPrompts } = require("../../../../utils/navigationHelpers");
    // eslint-disable-next-line global-require
    const store = require("../../../../store/configureStore").default;

    const navigateAction = () => {
        try {
            history.push(target.url, target.state || undefined);
            // A target's breadcrumb trail is applied whenever it CARRIES one — including an EMPTY array, which
            // is itself a real trail ("this page has no crumbs"). That matters for the back-navigation targets
            // built by navBackStore: returning to a page that had no breadcrumbs must CLEAR the destination's,
            // not leave them behind. Catalog targets that define no `bc` at all are untouched, as before.
            if (Array.isArray(target.bc)) bulkResetBreadCrumpData(target.bc);
        } catch (e) {
            /* best-effort: navigation failure must not break the assistant */
        }
    };
    navigateWithPrompts({ isFormDirty: readFormDirty(store), navigateAction });
    return true;
};
